import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Slides = lazy(() => import('../../container/slides'));

const SlideRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/slides`} component={Slides}/>
        </Switch>
    );
};

export default SlideRoutes;